import AddQuestionToFaq from './AddQuestionToFaq.component';

export default AddQuestionToFaq;